import {
    Car,
    Ear,
    Footprints,
    Forklift,
    Glasses,
    Hand,
    HardHat,
    Languages,
    Motorbike,
    Shield,
    Shirt,
    Truck,
    Wrench,
} from "lucide-react";

/** Lower case, without accents: "Chaussures de sécurité" and "chaussure securite" match. */
export const normalize = (value) =>
    String(value ?? "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .trim();

// Same families as the temp worker app (features/skills/toolIcon.js), so a piece of equipment
// shows the same icon on both sides.
const TOOL_FAMILIES = [
    { icon: Ear, words: ["anti-bruit", "antibruit", "auditi", "bouchon", "oreille"] },
    { icon: Footprints, words: ["chaussure", "botte", "sabot", "basket", "semelle"] },
    { icon: HardHat, words: ["casque", "casquette", "charlotte", "bonnet"] },
    { icon: Hand, words: ["gant", "manchette"] },
    { icon: Glasses, words: ["lunette", "visiere", "masque", "ecran facial"] },
    { icon: Shield, words: ["harnais", "longe", "antichute", "anti-chute", "genouill"] },
    {
        icon: Shirt,
        words: ["gilet", "veste", "tenue", "combinaison", "blouse", "pantalon", "tablier", "vetement", "parka", "tee-shirt", "t-shirt"],
    },
];

export const toolIcon = (name) => {
    const text = normalize(name);
    return TOOL_FAMILIES.find((family) => family.words.some((word) => text.includes(word)))?.icon ?? Wrench;
};

const MOTORBIKE = /\bpermis\s+(am|a1|a2|a)\b/;
const TRUCK = /\bpermis\s+(c1e|c1|ce|c)\b/;

// Same rules as the app (features/recommended/licenceIcon.js).
export const licenceIcon = (name) => {
    const text = normalize(name);
    if (text.includes("caces")) return Forklift;
    if (MOTORBIKE.test(text)) return Motorbike;
    if (TRUCK.test(text)) return Truck;
    return Car;
};

export const languageIcon = () => Languages;
